<template>
	<page>
		<module enable-flex>
			<m-search ref="search" @search="searchHandle">
				<c-form>
					<c-form-item type="input" label="岗位名称" name="title"></c-form-item>
					<c-form-item type="checkbox" name="state" :options="stateArray"></c-form-item>
				</c-form>
			</m-search>

			<m-operate>
				<c-button  icon="add" color="sys" @click="create()">添加</c-button>
			</m-operate>

			<c-table ref="table">
				<c-table-column
					label="岗位名称"
					name="title"
					width="250"
				>
				</c-table-column>

				<c-table-column
					label="招聘人数"
					name="recruiting_number"
					width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.extra_data_map && data.extra_data_map.recruiting_number">{{data.extra_data_map.recruiting_number}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="学历"
					name="degree"
					width="100"
				>
					<template v-slot="{data}">
						<span v-if="data.extra_data_map && data.extra_data_map.degree">{{data.extra_data_map.degree}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="工作地点"
					name="workplace"
					width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.extra_data_map && data.extra_data_map.workplace">{{data.extra_data_map.workplace}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="薪资范围"
					name="salary_range"
					width="120"
				>
					<template v-slot="{data}">
						<span v-if="data.extra_data_map && data.extra_data_map.salary_range">{{data.extra_data_map.salary_range}}</span>
						<span v-else>--</span>
					</template>
				</c-table-column>

				<c-table-column
					label="状态"
					name="state"
					width="80"
				>
					<template v-slot="{data}">
						<span v-if="data.state == 2" style="color:darkgreen;">启用</span>
						<span v-if="data.state == 1" style="color:red;">禁用</span>
					</template>
				</c-table-column>

                <c-table-column
                        type="sort"
                        label="排序"
                        name="sort_id"
                        @sort="sortHandle"
                >
                </c-table-column>

				<c-table-column
					label="创建日期"
					name="create_date"
                    width="145"
                >
				</c-table-column>

				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="200"
				>
					<template v-slot="{data}">
						<c-table-button  @click="edit(data)">编辑</c-table-button>
						<c-table-button  @click="del(data)">删除</c-table-button>
						<c-table-button  v-if="data.state == 1" @click="updateState(2, data)">{{'启用'}}</c-table-button>
						<c-table-button  v-if="data.state == 2" @click="updateState(1, data)">{{'禁用'}}</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>

		<c-dialog ref="editDialog" :title="editState ? '编辑招聘信息' : '添加招聘信息'" width="1000" height="650" @resolve="submitForm">
			<c-form ref="editForm">
				<c-form-item type="hidden" name="id"></c-form-item>
                <c-form-item type="hidden" name="language_type"></c-form-item>
                <c-form-item type="input" label="岗位名称" name="title" required></c-form-item>
                <c-form-item type="number" label="招聘人数" decimal="0" :limit="[1,99999]" name="recruiting_number" input-unit="人" required></c-form-item>
				<c-form-item type="input" label="学历" name="degree" required></c-form-item>
                <c-form-item type="input" label="工作地点" name="workplace" required></c-form-item>
                <c-form-item type="input" label="薪资范围" name="salary_range" required></c-form-item>
				<c-form-item type="editor" label="内容" name="content" required></c-form-item>
			</c-form>
		</c-dialog>
	</page>
</template>

<script>
export default {
	name: 'm_recruit_list',

    props: {
        languageType: Number        //2=英文  1=中文
    },

	data() {
		return {
			stateArray: [{
				name: '禁用',
				value: 1
			},{
				name: '启用',
				value: 2
			}],

			editState: false
		}
	},

	mounted() {
		this.$refs.search.search();
	},

	methods: {
		searchHandle(data) {
            data.language_type = this.languageType;
            this.$refs.table.load({
				url: '/website/recruit/list',
				data
			});
		},

		sortHandle(row, type, next) {
			//row.prev() 上一行数据
			//row.next() 下一行数据
			let submitData ={};
			if(type=='top' || type=='bottom'){
				submitData.type = type;
				submitData.id = row.data.id;
			}
			if(type=='up'){
				submitData.id1 = row.data.id;
				submitData.id2 = row.prev().data.id;
			}
			if(type=='down'){
				submitData.id1 = row.data.id;
				submitData.id2 = row.next().data.id;
			}
			this.request({
				url: '/website/recruit/sort',
				data: submitData,
				loading: true,
				success: data => {
					next();
				}
			});
		},

		create() {
			this.editState = false;
			this.$refs.editForm.clear();
            this.$refs.editForm.set({
                language_type:this.languageType,
                content:' '
            });
            this.$refs.editDialog.open();
		},

		edit(val) {
			this.editState = true;
			if(val.extra_data_map){
				val = Object.assign(val, val.extra_data_map)
			}
            this.$refs.editForm.clear();
            this.request({
                url: '/website/recruit/detail',
                data: {id:val.id},
                loading: true,
                success: data => {
                    this.$refs.editForm.set(data);
                    this.$refs.editDialog.open();
                }
            });
		},

		del(val) {
			this.$confirm({
				text: '确定要删除【'+val.title+'】吗？',  // 提示内容,
				buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					this.request({
						url: '/website/recruit/remove',
						data: {id:val.id},
						loading: true,
						success: data => {
							this.$message({
								text: '操作成功',
								icon: 'success'
							});
							this.$refs.table.update();
						}
					});
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},

		updateState(type,val) {
			this.$confirm({
				text: '确定要'+(type==2?'启用':'禁用')+'【'+val.title+'】吗？',  // 提示内容,
				buttonName: '确定',  // 确定按钮文字
				cancelButton: true,  // 是否显示取消按钮
				resolve: () => {
					this.request({
						url: '/website/recruit/update_state',
						data: {id:val.id,state:type},
						loading: true,
						success: data => {
							this.$message({
								text: '操作成功',
								icon: 'success'
							});
							this.$refs.table.update();
						}
					});
				},  // 确定按钮回调
				cancel: () => {},  // 取消按钮回调
			});
		},

		submitForm(stop) {
			stop();
			let submitUrl = '/website/recruit/add';
			if(this.editState){
				submitUrl = '/website/recruit/edit';
			}
			this.$refs.editForm.submit({
				url: submitUrl,
				rule: {
					title: [{
						type: 'empty',
						word: '请填写岗位名称'
					}],
                    recruiting_number: [{
						type: 'empty',
						word: '请填写招聘人数'
					}],
                    degree: [{
						type: 'empty',
						word: '请填写学历'
					}],
					workplace: [{
						type: 'empty',
						word: '请填写工作地点'
					}],
                    salary_range: [{
						type: 'empty',
						word: '请填写薪资范围'
					}],
					content: [{
						type: 'empty',
						word: '请填写岗位内容'
					}],
				},
				dataFormatter: data => {
                    data.language_type = this.languageType;
                    var extra_data_map = {};
						extra_data_map.recruiting_number = data.recruiting_number;
						extra_data_map.degree = data.degree;
						extra_data_map.workplace = data.workplace;
						extra_data_map.salary_range = data.salary_range;
					data.extra_data_map = extra_data_map;
					return data;
				},
				success:(data,res) => {
					this.$message({
						text: '操作成功',
						icon: 'success'
					});
					this.$refs.table.update();
					this.$refs.editDialog.close();
				},
			});
		}
	}
}
</script>